import React from 'react';

import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  TooltipProps
} from 'recharts';
import { SimpleBarChartDataItem } from '../../../models/charts';
import './index.css'
import { decimalToTime } from '../../BasicCalendar/Utils';

interface SimpleBarChartProps {
  data: SimpleBarChartDataItem[]
  barLegend?: string
  tooltips?: { [key: string]: string };
  yTicks?: (string | number)[]
  yTicksFormatter?: (v: any) => string
  renderBarLabel?: ({ ...params }: any) => React.ReactElement
  showValuesAsTime?: boolean
}


const SimpleBarChart: React.FC<SimpleBarChartProps> = ({
  data,
  yTicks,
  yTicksFormatter = (value) => value,
  renderBarLabel = undefined,
  barLegend,
  tooltips = {},
  showValuesAsTime = false
}) => {

  const yDomain = yTicks ? [0, yTicks[yTicks?.length - 1] as number] : undefined

  const getTooltipText = (label: string): string => {
    return tooltips[label] ?? ''
  };

  const CustomTooltip: React.FC<TooltipProps<number, string>> = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="chart-custom-tooltip">
          <p className="chart-custom-tooltip-label">{`${label} : ${(payload[0].value && showValuesAsTime) ? decimalToTime(payload[0].value) : payload[0].value}`}</p>
          <p className="chart-custom-tooltip-desc">{getTooltipText(label as string)}</p>
        </div>
      );
    }
    return null;
  };


  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        data={data}
      >

        <CartesianGrid strokeDasharray="3 3" />
        <XAxis name='Cantidad' dataKey="x" />
        <YAxis ticks={yTicks} tickFormatter={yTicksFormatter} domain={yDomain} />
        {barLegend && <Legend />}
        <Tooltip content={<CustomTooltip />} />
        <Bar dataKey='y' name={barLegend} barSize={30} fill="#8884d8" label={renderBarLabel ? ({ x, y, value }) => renderBarLabel({ x, y, value }) : undefined} />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default SimpleBarChart;
